<template>
  <div>
    <v-row>
      <span>{{ formValidator.getError("non_fields_errors") }}</span>
      <v-col md="4" cols="12">
        <v-text-field
          v-model="formData.name"
          label="Name"
          :error-messages="formValidator.getError('name')"
        ></v-text-field>
        <v-textarea
          v-model="formData.description"
          :error-messages="formValidator.getError('description')"
        >
          <template v-slot:label>
            <div>Description <small>Describe process task</small></div>
          </template>
        </v-textarea>

        <v-btn
          @click="submit"
          :disabled="Object.keys(formValidator.errors).length > 0 || loading"
          :loading="loading"
          >{{ formData.id ? "Update" : "Save" }}</v-btn
        >
        <v-btn @click="formData = { ...defaultFormData }" v-if="!formData.id"
          >Reset</v-btn
        >
        <v-btn v-if="formData.id" @click="removeObj">Delete</v-btn>
      </v-col>
      <v-col md="8" cols="12">
        <json-schema-editor
          v-model="formData.response_schema"
          :error-messages="formValidator.getError('response_schema')"
        ></json-schema-editor>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
import JsonSchemaEditor from "./JsonSchemaEditor";

export default {
  props: {
    objId: {
      type: [String, Number],
      default: ""
    },
    obj: {
      type: Object,
      default: () => {}
    },
    defaultFormData: {
      type: Object,
      default: () => {}
    }
  },
  resourceUrl: "/api/v1/crm/process-tasks/",
  components: {
    JsonSchemaEditor
  },
  data() {
    return {
      formData: { ...this.obj, ...this.defaultFormData },
      formValidator: new FormValidator(),
      loading: false
    };
  },
  mounted() {
    this.getObj();
  },

  watch: {
    "formData.id": function() {
      this.getObj();
    },
    formData: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    },
    defaultFormData: {
      handler: function(newVal) {
        this.formData = {
          ...this.formData,
          ...newVal
        };
      },
      deep: true
    },
    obj: {
      handler() {
        this.formData = { ...this.obj, ...this.defaultFormData };
        console.log(this.formData);
      },
      deep: true
    }
  },

  methods: {
    // START FORM-MIXIN
    submit() {
      const actionType = this.formData.id ? "put" : "post";
      let url = this.formData.id
        ? `${this.$options.resourceUrl}${this.formData.id}/`
        : this.$options.resourceUrl;

      this.loading = true;
      this.$axios[actionType](url, this.formData)
        .then(({ data }) => {
          this.$emit("action", { type: actionType, data });
          this.loading = false;
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully saved.`,
            color: "green"
          });
        })
        .catch(err => {
          this.formValidator.setError(err.response.data);
        });
    },
    removeObj() {
      const url = `${this.$options.resourceUrl}${this.formData.id}/`;
      this.loading = true;
      this.$axios.delete(url).then(() => {
        this.$emit("action", {
          type: "delete",
          data: { id: this.formData.id }
        });
        this.loading = false;
        this.$store.dispatch("shell/showSnackbar", {
          text: `Successfully deleted.`,
          color: "red"
        });
      });
    },
    getObj() {
      if (Object.keys(this.obj).length <= 0 && this.formData.id) {
        const url = `${this.$options.resourceUrl}${this.formData.id}/`;
        this.loading = true;
        this.$axios.$get(url).then(({ data }) => {
          this.formData = data;
          this.loading = false;
        });
      }
    }
    // END FORM MIXIN
  }
};
</script>
